import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { useRobotsViewModel } from "./Robots.vm";
import { RobotMap } from "../../helpers/RobotMap";

export const Robots: React.FC = () => {
	const vm = useRobotsViewModel();

	if (!vm.isDeveloper) {
		return (
			<Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "md", margin: "auto" }}>
				<Alert severity="error">You do not have permission to access this page.</Alert>
			</Box>
		);
	}

	return (
		<Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: "xl", margin: "auto" }}>
			<Typography variant="h5" sx={{ mb: 2 }}>
				Robots
			</Typography>

			{vm.error && (
				<Alert severity="error" sx={{ mb: 2 }}>
					{vm.error}
				</Alert>
			)}

			{vm.loading ? (
				<Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
					<CircularProgress />
				</Box>
			) : (
				<RobotMap robots={vm.robots} height="calc(100vh - 200px)" />
			)}
		</Box>
	);
};
